import { exportToBlob } from "@excalidraw/excalidraw";
import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

// Bound previews to the gallery's 800x600 area while preserving the scene
// aspect ratio. Smaller scenes are not upscaled, and non-4:3 scenes letterbox.
const PREVIEW_WIDTH = 800;
const PREVIEW_HEIGHT = 600;

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error("Unable to read drawing preview"));
    reader.onload = () => {
      const value = String(reader.result);
      resolve(value.slice(value.indexOf(",") + 1));
    };
    reader.readAsDataURL(blob);
  });
}

export async function createDrawingPreview(api: ExcalidrawImperativeAPI): Promise<string> {
  const blob = await exportToBlob({
    elements: api.getSceneElements(),
    appState: {
      ...api.getAppState(),
      exportBackground: true,
      exportWithDarkMode: false,
    },
    files: api.getFiles(),
    mimeType: "image/png",
    getDimensions: (width: number, height: number) => {
      const scale = Math.min(PREVIEW_WIDTH / width, PREVIEW_HEIGHT / height, 1);
      return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
        scale,
      };
    },
  });
  return blobToBase64(blob);
}
